import {
  BILLS_TO_ENTER,
  PAYABLES,
  PO_TRACKER,
  SUPPLIER_BILL_ADD,
  SUPPLIER_BILLS,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

// Payables (docs/store-gl-procure-to-pay-plan.md). Bills to Enter and the bill's own pages ride on
// the Supplier Bills feature; the tracker is its own.
export const PayablesRoutes: IAppRoutes = {
  link: PAYABLES,
  childrens: [
    {
      link: BILLS_TO_ENTER,
      element: guard(() => import('@modules/payables/BillsToEnter'), [SUPPLIER_BILLS]),
    },
    {
      link: SUPPLIER_BILLS,
      element: guard(() => import('@modules/payables/SupplierBills'), [SUPPLIER_BILLS]),
    },
    {
      link: SUPPLIER_BILL_ADD,
      element: guard(() => import('@modules/payables/SupplierBills/BillForm'), [SUPPLIER_BILLS]),
    },
    {
      link: `${SUPPLIER_BILLS}/edit/:id`,
      element: guard(() => import('@modules/payables/SupplierBills/BillForm'), [SUPPLIER_BILLS]),
    },
    {
      link: `${SUPPLIER_BILLS}/view/:id`,
      element: guard(() => import('@modules/payables/SupplierBills/BillView'), [SUPPLIER_BILLS]),
    },
    {
      link: PO_TRACKER,
      element: guard(() => import('@modules/payables/PoTracker'), [PO_TRACKER]),
    },
  ],
}
